import React from 'react';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router';
import { withRouter } from 'react-router-dom';

import queryString from 'query-string';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import TabInfo from './TabInfo';
import TabMatches from './TabMatches';
import TabSwipes from './TabSwipes';
import TabLocation from './TabLocation';
import TabReports from './TabReports';
import TabTokens from './TabTokens';
import TabAuthProviders from './TabAuthProviders';
import TabActions from './TabActions';

const styled = withStyles(theme => {
  return {
    container: {
      marginTop: 20,
      marginBottom: 20
    }
  };
});

class UserTabs extends React.Component {
  tabs = [
    'Info',
    'Swipes',
    'Matches',
    'Locations',
    'Reports',
    'Tokens/Devices',
    'Auth Providers',
    'Actions'
  ];

  getParams() {
    const defaultParams = {
      tab: 0
    };

    const parsed = queryString.parse(this.props.search);
    const params = Object.assign(defaultParams, parsed);
    params.tab = parseInt(params.tab);

    return params;
  }

  updateParams(newParams) {
    const params = this.getParams();
    const search = queryString.stringify(Object.assign(params, newParams));
    this.props.actions.replace(this.props.pathname + '?' + search);
  }

  handleTabChange = (event, value) => {
    this.updateParams({
      tab: value
    });
  };

  renderContent(tab) {
    if (tab === 0) {
      return <TabInfo />;
    } else if (tab === 1) {
      return <TabSwipes />;
    } else if (tab === 2) {
      return <TabMatches />;
    } else if (tab === 3) {
      return <TabLocation />;
    } else if (tab === 4) {
      return <TabReports />;
    } else if (tab === 5) {
      return <TabTokens />;
    } else if (tab === 6) {
      return <TabAuthProviders />;
    } else {
      return <TabActions />;
    }
  }

  render() {
    const { classes } = this.props;
    const params = this.getParams();

    return (
      <div>
        <Paper className={classes.container}>
          <Tabs
            onChange={this.handleTabChange}
            value={params.tab}
            variant="scrollable"
            scrollButtons="off"
          >
            <Tab label={this.tabs[0]} />
            <Tab label={this.tabs[1]} />
            <Tab label={this.tabs[2]} />
            <Tab label={this.tabs[3]} />
            <Tab label={this.tabs[4]} />
            <Tab label={this.tabs[5]} />
            <Tab label={this.tabs[6]} />
            <Tab label={this.tabs[7]} />
          </Tabs>
        </Paper>
        {this.renderContent(params.tab)}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    replace: payload => dispatch(replace(payload))
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(UserTabs))
);
